import firebase from '../firebase';
import { v4 as uuidv4 } from 'uuid';

export const addProduct = obj => {
	return async dispatch => {
		dispatch({ type: 'ADD_PRODUCT_REQUEST' });
		let data;
		let image = obj.imageURLID;
		let filename = image.name;
		let storageRef = await firebase
			.storage()
			.ref('medicine/' + filename)
			.put(image);

		let url = await storageRef.ref.getDownloadURL();
		data = {
			...obj,
			imageURLID: url,
		};

		await firebase
			.firestore()
			.collection('products')
			.add(data)
			.then(res => {
				dispatch({ type: 'ADD_PRODUCT_SUCCESS' });
				return 'response';
			})
			.catch(err => {
				dispatch({ type: 'ADD_PRODUCT_SUCCESS' });
				alert(err.message);
			});
	};
};

export const getProducts = () => {
	return async dispatch => {
		firebase
			.firestore()
			.collection('products')
			.onSnapshot(query => {
				let allProducts = [];
				query.forEach(doc => {
					allProducts.push({ id: doc.id, ...doc.data() });
				});
				dispatch({ type: 'GET_ALL_PRODUCT', payload: allProducts });
				return allProducts;
			});
	};
};

export const getProductsByCategory = category => {
	return async dispatch => {
		console.log('action', category);
	};
};
export const getSingleProduct = id => {
	return async dispatch => {
		await firebase
			.firestore()
			.collection('products')
			.doc(id)
			.get()
			.then(res => {
				dispatch({ type: 'GET_SINGLE_PRODUCTS', payload: res.data() });
				return res.data();
			});
	};
};

export const updateProduct = (id, obj) => async dispatch => {
	await firebase
		.firestore()
		.collection('products')
		.doc(id)
		.update(obj)
		.then(res => {
			dispatch({ type: 'UPDATE_PRODUCTS' });
			return 'response';
		});
};
export const deleteProduct = id => async dispatch => {
	await firebase
		.firestore()
		.collection('products')
		.doc(id)
		.delete()
		.then(res => {
			dispatch({ type: 'DELETE_PRODUCTS' });
			return 'response';
		});
};
